import { defaults } from 'mande';
import { defineStore } from 'pinia';

import { auth0 } from '../auth0.js';

export const useStore = defineStore('auth', {
  state: () => ({
    token: '',
    user: {}
  }),
  actions: {
    async setToken() {
      const token = await auth0.getAccessTokenSilently();
      defaults.headers.Authorization = `Bearer ${token}`;
      this.token = token;
    },
    async endServerSession() {
      try {
        const token = await auth0.getAccessTokenSilently({ cacheMode: 'cache-only' });
        if (!token) return;
        // Keep the request alive through the logout redirect.
        fetch(`${import.meta.env.VITE_APP_API_URL}/sessions`, {
          method: 'DELETE',
          keepalive: true,
          headers: { Authorization: `Bearer ${token}`, 'X-Etainabl-App': 'readings-ui' }
        }).catch(() => {});
      } catch {
        /* no cached token: log out locally regardless */
      }
    }
  }
});
